import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import ChildRow from "./ChildRow";
import io from "socket.io-client";
import {
  getConversation as getConversationService,
  readMessages as readMsgService,
  messageCount as messageCountService,
  getKidChatList,
} from "../../AxiosRtk/Messages";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { getPreSignedUrl, uploadFileToS3 } from "../../AxiosRtk/Miscellaneous";
import moment from "moment";
import useLangTranslation from "../../../customHooks/languageProvider";
import useCrypto from "../../../customHooks/crypto";
import DefaultImage from "../../../../assets/images/default-icon.png";
import useSubscription from "../../../customHooks/subscriptionProvider";
import TakePhotoModal from "../modals/TakePhotoModal";
import ViewPictureMessages from "../modals/ViewPictureMessages";
import ChatPhotoPreviewModal from "../modals/ChatPhotoPreviewModal";

const Messages = () => {
  const bottomRef = useRef(null);
  const [takePhotoModal, setTakePhotoModal] = useState({
    show: false,
    data: "",
  });

  const [imageUrl, setImageUrl] = useState("");
  const [viewPictureModal, setViewPictureModal] = useState(false);
  const { user } = useSelector(({ auth }) => auth);
  const [imageLoading, setImageLoading] = useState(false);
  const [kidChatList, setKidChatList] = useState([]);
  const [filteredKidList, setFilteredKeyList] = useState([]);
  const { dispatch, getImage } = useKidListFunctionality();
  const [chatSelectKid, setChatSelectKid] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [roomId, setRoomId] = useState(null);
  const [conversation, setConversation] = useState([]);
  const [socket, setSocket] = useState(null);
  const { getLangTranslation } = useLangTranslation();
  const [typedMsg, setTypedMsg] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [presignedData, setPresignedData] = useState("");
  const [image, setImage] = useState(null);
  const { checkSubsciption } = useSubscription();
  const { encodeNumberToBase64 } = useCrypto();
  const { kidList } = useSelector(({ dashboard }) => dashboard);

  const fetchChatKidList = () => {
    getKidChatList({ type: 1 })
      .then((res) => {
        if (res?.data?.status) {
          setKidChatList(
            res?.data?.result?.map((item) => {
              return {
                ...item,
                ID: item?.childId,
                childName: item?.name,
                parentID: user?.ID,
              };
            })
          );
        }
      })
      .catch((err) => console.log("fetch chat list error", err));
  };

  useEffect(() => {
    fetchChatKidList();
  }, []);

  useEffect(() => {
    if (kidChatList?.length > 0) {
      setChatSelectKid(kidChatList[0]);
      setFilteredKeyList(kidChatList);
    }
  }, [kidChatList]);

  const messagesEndRef = useRef(null);

  const closeViewPicture = () => {
    setViewPictureModal(false);
  };

  const openViewPicture = (url) => {
    setSelectedItem(url);
    setViewPictureModal(true);
  };

  const getConversation = async (roomId) => {
    try {
      const { data } = await getConversationService({ roomId });
      if (data) {
        setConversation(data?.result);
        if (data?.result?.length > 0) {
          updateReadMesage(data?.result);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversation]);

  const fetchSlotData = async () => {
    const req = {
      kidId: chatSelectKid?.ID,
      parentId: chatSelectKid?.parentID,
    };
    try {
      const { data } = await messageCountService(req);
    } catch (error) {
      console.log(error);
    }
  };

  const updateReadMesage = async (update) => {
    if (update) {
      const ids = update?.map((item) => item.messageId);
      const req = {
        type: 1,
        id: ids,
        isKidRead: 0,
      };
      try {
        const { data } = await readMsgService(req);
        if (data) {
          fetchSlotData();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const connectToRoom = () => {
    const req = {
      userId: chatSelectKid?.parentID,
      kidId: chatSelectKid?.ID,
      userType: 1,
    };
    try {
      socket.emit("create-room", req);

      socket.on("room-id-response", (data) => {
        setRoomId(data?.roomId);
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const CONNECTION_PORT = process.env.REACT_APP_CONNECTION_PORT_NEW;
    setSocket(io(CONNECTION_PORT));
  }, []);

  useEffect(() => {
    if (socket && chatSelectKid) {
      connectToRoom();
    }
  }, [chatSelectKid]);

  useEffect(() => {
    if (roomId) {
      getConversation(roomId);
      const interval = setInterval(() => getConversation(roomId), 30000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [roomId]);

  function handleMessageSubmit() {
    if (!checkSubsciption()) {
      return;
    } else {
      const req = {
        userId: chatSelectKid?.parentID,
        roomId: roomId,
        message: imageUrl ? imageUrl : typedMsg,
        userType: 1,
        type: imageUrl ? 2 : 1,
      };
      socket.emit("add-message", req);
      socket.on("add-message-response", (data) => {
        if (data) {
          setTimeout(getConversation(roomId), 10000);
          setImageUrl("");
          setImagePreviewModal(false);
        }
      });

      setTypedMsg("");
    }
  }

  function handleKeyPress(event) {
    if (event?.key === "Enter" && !event?.shiftKey) {
      event?.preventDefault();
      handleMessageSubmit();
    }
  }

  function handleInputChange(e) {
    setTypedMsg(e.target.value);
  }

  const handleImageUpload = async (event) => {
    if (!checkSubsciption()) {
      return;
    } else {
      setImageLoading(true);
      const payload = {
        type: "put",
        fileName: `${encodeNumberToBase64(chatSelectKid?.parentID)}/ChatPics/${event.target.files[0].name
          }`,
      };
      try {
        getPreSignedUrl(payload)
          .then((res) => {
            setPresignedData(res?.data?.result);
          })
          .catch((err) => {
            console.log(
              "catch error presigned url ==>>",
              err?.response?.data?.message
            );
          });
      } catch (error) {
        console.log(error);
      }

      setImage({ file: event.target.files[0] });
    }
  };

  const handleClickedImageUpload = (file) => {
    if (!checkSubsciption()) {
      return;
    } else {
      setImageLoading(true);
      const payload = {
        type: "put",
        fileName: file.name,
      };
      try {
        getPreSignedUrl(payload)
          .then((res) => {
            setPresignedData(res?.data?.result);
          })
          .catch((err) => {
            console.log(
              "catch error presigned url ==>>",
              err?.response?.data?.message
            );
          });
      } catch (error) {
        console.log(error);
      }

      setImage({ file: file });
    }
  };

  useEffect(() => {
    if (presignedData) {
      uploadFileToS3(`${presignedData?.signedUrlForPutObject}`, image?.file, {
        "Content-Type": image?.file.type,
        version_code: 20000,
      })
        .then((res) => {
          const message = `${image?.file?.name}`;

          setImageUrl(message);
          setImageLoading(false);
          setImagePreviewModal(true);
        })
        .catch((error) => {
          console.log(
            "upload to s3 catch error ==>>",
            error?.response?.data?.message
          );
          setImageLoading(false);
        });
    }
  }, [presignedData]);

  useEffect(() => {
    if (searchKey) {
      const filterData = kidChatList?.filter((item) =>
        item?.childName?.toLowerCase()?.includes(searchKey?.toLowerCase())
      );
      setFilteredKeyList(filterData);
      setChatSelectKid(filterData[0]);
      if (filterData[0].ID != chatSelectKid.ID) setConversation([]);
    } else {
      setFilteredKeyList(kidChatList);
    }
  }, [searchKey]);

  const handleCloseTakePhotoModal = () => {
    setTakePhotoModal({ show: false, data: "" });
  };

  const handleCameraDoneClick = (file) => {
    handleClickedImageUpload(file);
    setTakePhotoModal({ show: false, data: "" });
  };
  const handleOpenTakePhotoModal = () => {
    setTakePhotoModal({ show: true, data: "" });
  };

  // Check if the child has a device
  const isChildDeviceAvailable = chatSelectKid?.KidsDevices?.some(item => item.KidsDeviceId);

  function generateImageUrl(message) {
    if (!message?.includes("ChatPics")) {
      return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW
        }/${encodeNumberToBase64(chatSelectKid?.parentID)}/ChatPics/${message}`;
    }

    return `${process.env.REACT_APP_AMAZON_S3_IMAGE_URL_PREFIX_NEW
      }/${encodeNumberToBase64(chatSelectKid?.parentID)}/${message}`;
  }

  // Fetch lang data
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <>
      {/* Take Photo Modal */}
      <TakePhotoModal
        show={takePhotoModal?.show}
        handleClose={handleCloseTakePhotoModal}
        onDone={handleCameraDoneClick}
        getLangTranslation={getLangTranslation}
      />
      {/* Image Preview Modal */}
      <ChatPhotoPreviewModal
        show={imagePreviewModal}
        handleClose={() => {
          setImagePreviewModal(false);
          setImageUrl("");
        }}
        onDecline={() => {
          setImagePreviewModal(false);
          setImageUrl("");
        }}
        onSend={() => {
          handleMessageSubmit();
        }}
        imageUrl={generateImageUrl(imageUrl)}
        loading={imageLoading}
        getLangTranslation={getLangTranslation}
      />
      <div className="card">
        <div
          className={`card-body ${lang?.isRTL === 1 ? "ps-6 ps-xl-0" : "pe-6 pe-xl-0"
            }`}
        >
          <div className="message-wrap">
            <div className="message-left ">
              <div className={`${lang?.isRTL === 1 ? "ps-xl-6" : "pe-xl-6"}`}>
                <h3 className="text-blue-900 mb-6">
                  {getLangTranslation("PARENT_MESSAGE_TITLE", "Messages")}
                </h3>
              </div>
              <ul
                className={`user-message-list  ${lang?.isRTL === 1 ? "ps-xl-6 pe-xl-0" : "pe-xl-6"
                  }`}
              >
                {kidList?.map((item, index) => {
                  return (
                    <ChildRow
                      item={item}
                      key={index}
                      dispatch={dispatch}
                      getImage={getImage}
                      setChatSelectKid={setChatSelectKid}
                      chatSelectKid={chatSelectKid}
                    />
                  );
                })}
              </ul>
            </div>
            <div
              className={`message-right flex-fill ${lang?.isRTL === 1 ? "pe-xl-6" : "ps-xl-6"
                }`}
            >
              <ul
                className={`message-body-wrap ${lang?.isRTL === 1 ? "ps-xl-6 pe-xl-0" : "pe-xl-6"
                  }`}
                ref={messagesEndRef}
              >
                {conversation?.map((item, i) => {
                  return (
                    <>
                      {moment(conversation[i]?.dateCreated)
                        .locale("en")
                        .format("YYYY-MMM-DD") !==
                        moment(conversation[i - 1]?.dateCreated)
                          .locale("en")
                          .format("YYYY-MMM-DD") && (
                          <li key={item?.messageId + 1}>
                            <div className="unseen-message my-4">
                              <span className="text-small text-gray text-uppercase bg-white position-relative px-6">
                                {moment(item?.dateCreated)
                                  .locale("en")
                                  .format("YYYY-MMM-DD")}
                              </span>
                            </div>
                          </li>
                        )}
                      <li key={item?.messageId + 2}>
                        <div
                          className={`message-body ${item?.senderId === chatSelectKid?.parentID
                            ? "message-sent"
                            : ""
                            }`}
                        >
                          {item?.type === 2 ? (
                            <>
                              <div className="chat-img-view ratio ratio-1x1">
                                <img
                                  src={generateImageUrl(item?.Message)}
                                  alt=""
                                  height={50}
                                  width={50}
                                  className="pt-cursor"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DefaultImage;
                                  }}
                                  onClick={() => {
                                    openViewPicture(
                                      generateImageUrl(item?.Message)
                                    );
                                  }}
                                />
                              </div>
                            </>
                          ) : (
                            <p className="mb-0 text-break">{item?.Message}</p>
                          )}
                        </div>
                      </li>
                    </>
                  );
                })}
                <div ref={bottomRef} />
              </ul>

              {/* {!imageLoading && (
                <div
                  className={`input-group  ${
                    lang?.isRTL === 1 ? "ps-xl-6" : "pe-xl-6"
                  }`}
                >
                  <span
                    className={`input-group-text pt-cursor custom-file-wrap rounded-pill  ${
                      lang?.isRTL === 1
                        ? "rounded-start border-start-0"
                        : "rounded-end border-end-0"
                    }`}
                  >
                    <i className="icon-link fs-5">
                      <input
                        type="file"
                        onChange={(e) => handleImageUpload(e)}
                        disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device
                      />
                    </i>
                  </span>
                  <span
                    className="input-group-text pt-cursor custom-file-wrap border-end-0 border-start-0"
                    onClick={handleOpenTakePhotoModal}
                    disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device
                  >
                    <i className="icon-camera fs-5"></i>
                  </span>

                  <textarea
                    className="form-control border-end-0 border-start-0"
                    rows="1"
                    onKeyPress={handleKeyPress}
                    onChange={handleInputChange}
                    value={typedMsg}
                    disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device
                  ></textarea>

                  <button
                    type="submit"
                    disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device or if neither image nor message is present
                    className={`input-group-text rounded-pill ${
                      lang?.isRTL === 1
                        ? "rounded-end border-end-0"
                        : "rounded-start border-start-0"
                    }`}
                    onClick={() => handleMessageSubmit()}
                  >
                    <span className="icon-wrap rounded-circle p-0 bg-blue-300 ">
                      <i className="icon-send text-white pt-cursor" />
                    </span>
                  </button>
                </div>
              )} */}

              {isChildDeviceAvailable ? (
                <div
                  className={`input-group  ${lang?.isRTL === 1 ? "ps-xl-6" : "pe-xl-6"
                    }`}
                >
                  <span
                    className={`input-group-text pt-cursor custom-file-wrap rounded-pill  ${lang?.isRTL === 1
                      ? "rounded-start border-start-0"
                      : "rounded-end border-end-0"
                      }`}
                  >
                    <i className="icon-link fs-5">
                      <input
                        type="file"
                        onChange={(e) => handleImageUpload(e)}
                      // disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device
                      />
                    </i>
                  </span>
                  <span
                    className="input-group-text pt-cursor custom-file-wrap border-end-0 border-start-0"
                    onClick={handleOpenTakePhotoModal}
                  // disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device
                  >
                    <i className="icon-camera fs-5"></i>
                  </span>

                  <textarea
                    className="form-control border-end-0 border-start-0"
                    rows="1"
                    onKeyPress={handleKeyPress}
                    onChange={handleInputChange}
                    value={typedMsg}
                  // disabled={!isChildDeviceAvailable} // Disable if child doesn't have a device
                  ></textarea>

                  <button
                    type="submit"
                    // disabled={!isChildDeviceAvailable || (!imageUrl && !typedMsg)} // Disable if child doesn't have a device or if neither image nor message is present
                    className={`input-group-text rounded-pill ${lang?.isRTL === 1
                      ? "rounded-end border-end-0"
                      : "rounded-start border-start-0"
                      }`}
                    onClick={() => handleMessageSubmit()}
                  >
                    <span className="icon-wrap rounded-circle p-0 bg-blue-300 ">
                      <i className="icon-send text-white pt-cursor" />
                    </span>
                  </button>
                </div>
              ) : (
                <div className="text-center my-5">
                  {`${getLangTranslation('CONNECT_DEVICE_BUTTON_CONNECT', 'CONNECT')} ${chatSelectKid?.childName} ${getLangTranslation('CHAT_ERROR_CONNECT_DEVICE_FIRST', 'device first')}`}
                </div>

              )}

              {imageLoading && (
                <div className="d-flex justify-content-center">
                  <Box sx={{ display: "flex" }}>
                    <CircularProgress />
                  </Box>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ViewPictureMessages
        showModal={viewPictureModal}
        closeModal={closeViewPicture}
        selectedItem={selectedItem}
        getLangTranslation={getLangTranslation}
      />
    </>
  );
};

export default Messages;
